import { r as registerInstance, c as createEvent, h } from './index-5faac9d7.js';
import { i as isEmpty_1 } from './isEmpty-51908328.js';
import { o as omitBy_1, i as isNil_1 } from './omitBy-313ebee0.js';
import { c as EQdsButtonImportance, aC as PRIMARY_BUTTONS, aD as SECONDARY_BUTTONS } from './currency-7be6806c.js';
import './index-e29b327a.js';
import { b as getDownloadButtonIcon, g as getDownloadButtonLabel } from './utils-5735b62e.js';
import { c as findProductFeedMinimalPrice, d as applyPriceTemplate, w as weeePricesToTextArray } from './price-057947a0.js';
import { a as format } from './index-e233ecdd.js';
import './_nodeUtil-f95b2b52.js';
import './_commonjsHelpers-11ca3be1.js';
import './_baseIteratee-285d44d0.js';
import './_Stack-68736bd1.js';
import './_arrayLikeKeys-728b0edd.js';
import './isSymbol-bae590b5.js';
import './toString-10b0f228.js';
import './_isIndex-3036d479.js';
import './_getAllKeys-407edbf9.js';
import './hasIn-53d8ae96.js';
import './_basePickBy-e4f30088.js';
import './keysIn-6ff99c07.js';
import './_getAllKeysIn-c79cfca8.js';
import './lodash-bd96d09c.js';
import './analytics-205f1857.js';
import './flatMap-f62e8c63.js';
import './_baseFlatten-65704796.js';
import './_baseFor-a28737de.js';

const ctaAreaSeContainerCss = ":host{display:block}@media screen and (min-width: 980px){:host{border-top:1px solid #e7e6e6}}";

const CtaAreaSeContainer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.buyOnlineClick = createEvent(this, "buyOnlineClick", 7);
    this.notifyButtonDidClick = createEvent(this, "notifyButtonDidClick", 7);
    this.downloadButtonDidClick = createEvent(this, "downloadButtonDidClick", 7);
    this.addToCartButtonDidClick = createEvent(this, "addToCartButtonDidClick", 7);
    this.getProductFeedMinimalPriceText = () => {
      const product = this.getCurrentProductFeed();
      const price = findProductFeedMinimalPrice(product);
      const { countryLanguageCode, priceTemplate } = this.commerceConnectorSettings.options;
      if (!price || !countryLanguageCode || !priceTemplate) {
        return null;
      }
      const formattedPrice = format(price, { locale: countryLanguageCode });
      return applyPriceTemplate(formattedPrice, priceTemplate);
    };
    this.productId = undefined;
    this.commerceConnectorSettings = undefined;
    this.productsFeed = undefined;
    this.ctaData = undefined;
    this.addToMyProductsLabel = undefined;
    this.removeFromMyProductsLabel = undefined;
    this.compareLabel = undefined;
    this.downloadLabel = undefined;
    this.showBuyOnline = undefined;
    this.isStickyBar = undefined;
    this.materialPriceGroup = undefined;
    this.imageUrl = undefined;
    this.imageTitle = undefined;
    this.showCompare = undefined;
    this.showFavorites = false;
    this.showSkeleton = false;
    this.isInMyProductsList = false;
    this.softwareDocuments = undefined;
    this.addToCartButtonRendered = false;
  }
  getPriceTextContent() {
    return this.showPartnerPrice()
      ? this.getProductFeedMinimalPriceText()
      : this.getProductPriceText();
  }
  showPartnerPrice() {
    var _a, _b, _c;
    return ((_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.enablePrice) && ((_c = this.productsFeed) === null || _c === void 0 ? void 0 : _c.length) > 0;
  }
  isPriceAvailable() {
    var _a, _b;
    return !!(((_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.price) && ((_b = this.ctaData) === null || _b === void 0 ? void 0 : _b.currency));
  }
  getProductPriceText() {
    return this.isPriceAvailable() ? `${this.ctaData.price}&nbsp;${this.ctaData.currency}` : null;
  }
  getCurrentProductFeed() {
    var _a;
    return (_a = this.productsFeed) === null || _a === void 0 ? void 0 : _a.find((product) => (product === null || product === void 0 ? void 0 : product.ProductId) === this.productId);
  }
  hasTooltip() {
    var _a;
    return !this.showPartnerPrice() && !isEmpty_1((_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.weeePrices);
  }
  renderWeeePrices() {
    if (!this.hasTooltip()) {
      return null;
    }
    return weeePricesToTextArray(this.ctaData.weeePrices).map((text) => h("div", { innerHTML: text }));
  }
  findButtonType(buttonTypes) {
    return buttonTypes.find((type) => { var _a, _b; return type in ((_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) !== null && _b !== void 0 ? _b : {}); });
  }
  renderButtonFactory(type, isSticky) {
    var _a, _b;
    const button = (_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b[type];
    if (!button) {
      return null;
    }
    switch (type) {
      case "BUY_ONLINE_BUTTON_REGULAR":
      case "BUY_ONLINE_BUTTON_APC":
        return this.renderBuyOnlineButton();
      case "NOTIFY_ME_BUTTON":
        return this.renderNotifyMeButton(button);
      case "ADD_TO_CART_BUTTON":
        return this.renderAddToCartButton(button, isSticky);
      case "DOWNLOAD_BUTTON":
        return this.renderDownloadButton(button);
      default:
        return null;
    }
  }
  renderBuyOnlineButton() {
    var _a, _b, _c, _d;
    const regularButton = (_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b.BUY_ONLINE_BUTTON_REGULAR;
    const apcButton = (_d = (_c = this.ctaData) === null || _c === void 0 ? void 0 : _c.buttons) === null || _d === void 0 ? void 0 : _d.BUY_ONLINE_BUTTON_APC;
    const buttonProps = {};
    if (regularButton && this.showBuyOnline) {
      buttonProps.label = regularButton.labels.defaultLabel;
      buttonProps.onClick = () => this.buyOnlineClick.emit();
    }
    else if (apcButton === null || apcButton === void 0 ? void 0 : apcButton.link) {
      buttonProps.label = apcButton.labels.defaultLabel;
      buttonProps.icon = "arrow-top-right-on-square";
      buttonProps.onClick = () => this.buyOnlineClick.emit(apcButton.link);
    }
    return isEmpty_1(buttonProps) ? null : buttonProps;
  }
  renderAddToCartButton(button, isSticky) {
    this.addToCartButtonRendered = true;
    return {
      importance: EQdsButtonImportance.STANDARD,
      icon: "shopping-cart",
      label: button.labels.defaultLabel,
      onClick: (e) => {
        this.addToCartButtonDidClick.emit({ initialEvent: e, isStickyBar: isSticky });
      },
    };
  }
  renderNotifyMeButton(button) {
    return {
      label: button.labels.defaultLabel,
      onClick: () => this.notifyButtonDidClick.emit(button.link),
    };
  }
  renderDownloadButton(button) {
    return {
      icon: getDownloadButtonIcon(this.softwareDocuments),
      label: getDownloadButtonLabel(this.softwareDocuments, button, this.downloadLabel),
      onClick: () => this.downloadButtonDidClick.emit(),
    };
  }
  renderPrimaryButton(isSticky) {
    const buttonType = this.findButtonType(PRIMARY_BUTTONS);
    return this.renderButtonFactory(buttonType, isSticky);
  }
  renderSecondaryButton(isSticky) {
    const buttonType = this.findButtonType(SECONDARY_BUTTONS);
    return this.renderButtonFactory(buttonType, isSticky);
  }
  mapCtaButtons(isSticky = false) {
    return omitBy_1({
      emphasized: this.renderPrimaryButton(isSticky),
      standard: [this.renderSecondaryButton(isSticky)],
    }, isNil_1);
  }
  getPriceFromLabel() {
    var _a, _b;
    return this.showPartnerPrice() ? (_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.priceFrom : null;
  }
  isFavoritesAllowed() {
    return this.showFavorites && !this.addToCartButtonRendered;
  }
  renderStickyCtaArea() {
    return (h("pes-cta-area-view-sticky", { imageUrl: this.imageUrl, imageTitle: this.imageTitle, priceHTML: this.getPriceTextContent(), tooltipHTML: this.renderWeeePrices(), buttons: this.mapCtaButtons(true), priceFromLabel: this.getPriceFromLabel(), addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, showFavorites: this.isFavoritesAllowed(), isInFavorites: this.isInMyProductsList }));
  }
  render() {
    var _a, _b, _c;
    if (this.isStickyBar) {
      return this.renderStickyCtaArea();
    }
    return (h("pes-cta-area-view", { productId: this.productId, priceHTML: this.getPriceTextContent(), tooltipHTML: this.renderWeeePrices(), buttons: this.mapCtaButtons(), showSkeleton: this.showSkeleton, materialPriceGroup: this.materialPriceGroup, priceFromLabel: this.getPriceFromLabel(), compareLabel: this.compareLabel, addedToCartLabel: (_c = (_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.addedToCart) !== null && _c !== void 0 ? _c : null, showAddedToCartLabel: this.addToCartButtonRendered && this.isInMyProductsList, isInFavorites: this.isInMyProductsList, showCompare: this.showCompare, addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, showFavorites: this.isFavoritesAllowed() }));
  }
};
CtaAreaSeContainer.style = ctaAreaSeContainerCss;

export { CtaAreaSeContainer as pes_cta_area_se_container };
